import React, { Component } from 'react'
import { Joyride, ACTIONS, EVENTS } from 'react-joyride'

import TourTooltip from 'components/molecules/tourTooltip'
import { getUnseenSteps } from './helpers'
import { stepsStatusHash } from 'utilities/stepsStatusHash'
import QAPVars from 'qap/vars'

type Props = {
  feature: string;
  featureTours: any;
  run: boolean;
  steps: Array<any>;
  updateFeatureTour: <T>(data: T) => void;
  phase: 'new' | 'returning';
  unviewedReturning: Array<any>;
};

class Tour extends Component<Props> {
  static defaultProps = {
    run: true,
    phase: 'returning',
    unviewedReturning: [],
  }

  handleCallback = ({
    type,
    action,
  }: any) => {
    const { steps, phase, unviewedReturning, updateFeatureTour } = this.props
    let newStatus

    if (action === ACTIONS.SKIP) {
      newStatus = 'dismissed'
    } else if (type === EVENTS.TOUR_END) {
      newStatus = 'viewed'
    }

    if (!newStatus) return

    let payload = stepsStatusHash({ newStatus, steps })

    if (phase === 'new' && unviewedReturning.length > 0) {
      payload = {
        ...payload,
        ...stepsStatusHash({ newStatus: 'dismissed', steps: unviewedReturning }),
      }
    }

    updateFeatureTour<{
      [key: string]: string;
    }>(payload)
  }

  render () {
    const { steps } = this.props
    const unseenSteps = getUnseenSteps({ steps })
    if (unseenSteps.length === 0) return null

    return (
      <Joyride
        continuous
        run={this.props.run}
        locale={{ last: 'Done' }}
        tooltipComponent={TourTooltip}
        options={{
          showProgress: true,
          buttons: ['back', 'close', 'primary', 'skip'],
          overlayClickAction: false,
          scrollOffset: 100,
          overlayColor: 'rgba(0, 0, 0, 0.2)',
          primaryColor: QAPVars.pRed,
          arrowSize: 8,
          arrowBase: 16
        }}
// @ts-expect-error - TS2322 - Type 'TourStep[]' is not assignable to type '{ beaconComponent?: ElementType<BeaconRenderProps> | undefined; disableCloseOnEsc?: boolean | undefined; disableOverlay?: boolean | undefined; ... 23 more ...; title?: ReactNode; }[]'.
        steps={unseenSteps}
        onEvent={this.handleCallback}
      />
    )
  }
}

export default Tour
